import React from "react"

import "./content.css"

const Content = () => ( <
    div className = "content" >
    <
    h1 > Hi Buddy < /h1> <
    p > Welcome to the Smart Creative playground. < /p> <
    p > Click on the rotating box and go build something great. < /p> <
    p > You can use mouse and arrow keys to move around. < /p> <
    p > Here, Everyone is Creative! < /p> <
    p > < marquee > @paajoe < /marquee></p >
    <
    /div>
)

export default Content